// extracted by mini-css-extract-plugin
module.exports = {"workspaces":"AccountsDashboardComponent_workspaces__3PGM6"};